import { events } from '../Notifications/reducers/trackerNotifications';

const permissions = {
  videoDashboard: 'VD001',
  eventsHistory: 'VD002'
};

export default permissions;
